import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-page min-h-screen" }
const _hoisted_2 = {
  key: 0,
  class: "px-10 pt-10"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "list-item-status green-status"
}
const _hoisted_5 = {
  key: 1,
  class: "list-item-status blue-status"
}
const _hoisted_6 = {
  key: 2,
  class: "list-item-status orange-status"
}
const _hoisted_7 = {
  key: 3,
  class: "list-item-status orange-status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListTitle = _resolveComponent("ListTitle")!
  const _component_ListNewItem = _resolveComponent("ListNewItem")!
  const _component_EmptyPage = _resolveComponent("EmptyPage")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.refreshing,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.refreshing) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: _ctx.loading,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
          finished: _ctx.finished,
          "finished-text": "没有更多了",
          onLoad: _ctx.onLoad
        }, {
          default: _withCtx(() => [
            (_ctx.visitorList.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitorList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "flex flex-col list-item",
                      onClick: ($event: any) => (
              _ctx.$router.push({
                name: _ctx.$RouterName.VISITOR_DETAILS,
                query: {
                  id: item.id
                }
              })
            )
                    }, [
                      _createVNode(_component_ListTitle, {
                        name: item.code
                      }, null, 8, ["name"]),
                      _createVNode(_component_ListNewItem, {
                        style: {"margin-top":"8px"},
                        label: "访问公司",
                        value: item.visit_stores_name
                      }, null, 8, ["value"]),
                      _createVNode(_component_ListNewItem, {
                        label: "来访人",
                        value: item.person_lists.map((item) => item.name).join(',')
                      }, null, 8, ["value"]),
                      _createVNode(_component_ListNewItem, {
                        label: "访问时间",
                        value: `${item.person_date} ${item.person_time}`
                      }, null, 8, ["value"]),
                      (item.state == '1')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "待审批"))
                        : _createCommentVNode("", true),
                      (item.state == '2')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "已通过"))
                        : _createCommentVNode("", true),
                      (item.state == '3')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "未通过"))
                        : _createCommentVNode("", true),
                      (item.state == '4')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.state_name), 1))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_3))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock(_component_EmptyPage, {
                  key: 1,
                  style: {"margin-top":"100px !important"},
                  isHide: true
                }))
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ]))
}